import { NARRATIVE_FRAGMENT } from './narrativeFragment';
import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';
import { NARRATIVE_SIDEBAR_COMPANY_FRAGMENT } from '../../components/NarrativeSidebar/narrativeSidebarFragment';
import { NARRATIVE_HEADER_COMPANY_FRAGMENT } from '../../components/PublicNarrativeHeader/narrativeCompanyFragment';

const QUERY = gql(
  `
  query NarrativeById($narrativeId: ID!) {
    narrative(ref: $narrativeId) {
      ...NarrativeFields
      company {
        ...NarrativeSidebarCompanyFields
        ...NarrativeHeaderCompanyFields
      }
    }
  }
`,
  [
    NARRATIVE_FRAGMENT,
    NARRATIVE_HEADER_COMPANY_FRAGMENT,
    NARRATIVE_SIDEBAR_COMPANY_FRAGMENT,
  ]
);

export const useNarrativeById = makeGqlQuery(QUERY, {
  tags: ['narrative'],
});
